import { NotificationBarProvider, DropZoneProvider, UserProvider, StatusNotification, ErrorBoundary, IpRestriction } from '@mdc/ui';
import { UploadPreloaderProvider } from '@mdc/services';
import { I18nextProvider } from 'react-i18next';

import PropTypes from 'prop-types';

export const WrapRootElement = ({ element }, i18nObject) => {

    return (
        <I18nextProvider i18n={i18nObject}>
            <ErrorBoundary>
                <UserProvider>
                    <IpRestriction>
                        <UploadPreloaderProvider>
                            <NotificationBarProvider>
                                <DropZoneProvider>
                                    <StatusNotification>
                                        {element}
                                    </StatusNotification>
                                </DropZoneProvider>
                            </NotificationBarProvider>
                        </UploadPreloaderProvider>
                    </IpRestriction>
                </UserProvider>
            </ErrorBoundary>
        </I18nextProvider>
    );
};

WrapRootElement.propTypes = {
    element: PropTypes.node.isRequired,
};
